import { render, staticRenderFns } from "./eventList.vue?vue&type=template&id=4db2a9c8&scoped=true&"
import script from "./eventList.vue?vue&type=script&lang=js&"
export * from "./eventList.vue?vue&type=script&lang=js&"
import style0 from "./eventList.vue?vue&type=style&index=0&id=4db2a9c8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4db2a9c8",
  null
  
)

export default component.exports